import unit12img from './static/thumbnails 3/Unit_12_thumb.jpg';
import unit13img from './static/thumbnails 3/Unit_13_thumb.jpg';
import unit14img from './static/thumbnails 3/Unit_14_thumb.jpg';
import unit15img from './static/thumbnails 3/Unit_15_thumb.jpg';
import unit17img from './static/thumbnails 3/Unit_17_thumb.jpg';
import unit18img from './static/thumbnails 3/Unit_18_thumb.jpg';
import unit19img from './static/thumbnails 3/Unit_19_thumb.jpg';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  "units": [
    {
      id: 0,
      url: "https://gsa-pointclouds.s3.af-south-1.amazonaws.com/unit-12/index.html",
      name: "Unit 12",
      image:  unit12img,
      students: [
        {
          name: 'Gareth How',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/gareth-how'
        },
        {
          name: 'Aisha Balde',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/aisha-balde'
        },
        {
          name: 'Tova Lubinsky',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/tova-lubinsky'
        },
        {
          name: 'Sarah Treherne',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/sarah-treherne'
        },
        {
          name: 'Jody van Aswegen',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/jody-van-aswegen'
        },
        {
          name: 'Sabine Waskow',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/sabine-waskow'
        },
        {
          name: 'Adwoa Agyei',
          url: 'https://www.gsaujsummershow2020.com/adwoa-agyei'
        },
        {
          name: 'Steffen Fischer',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/steffen-fischer'
        },
        {
          name: 'Terrence Mkhwanazi',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/terrence-mkhwanazi'
        },
        {
          name: 'Frederick Kannemeyer',
          url: 'https://www.gsaujsummershow2020.com/frederick-kannemeyer'
        },
        {
          name: 'Heidi Lu',
          url: 'https://www.gsaujsummershow2020.com/heidi-lu'
        },
        {
          name: 'Roanne Moodley',
          url: 'https://www.gsaujsummershow2020.com/roanne-moodley'
        },
        {
          name: 'Gugulethu Mthembu',
          url: 'https://www.gsaujsummershow2020.com/gugulethu-mthembu'
        },
        {
          name: 'Tonia Murray',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/tonia-murray'
        },
        {
          name: 'Gloria Pavita',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/gloria-pavita'
        },
        {
          name: 'Kamal Ranchod',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/kamal-ranchod'
        },
        {
          name: 'Chris Rojas',
          url: 'https://www.gsaujsummershow2020.com/unit-12r/chris-rojas'
        }
      ]
    },
    {
      id: 1,
      url: "https://gsa-pointclouds.s3.af-south-1.amazonaws.com/unit-13/index.html",
      name: "Unit 13",
      image:  unit13img,
      students: [
        {
          name: 'Demi Bridgland',
          url: 'https://www.gsaujsummershow2020.com/demi-bridgland'
        },
        {
          name: 'Lesego Tsatsimpe',
          url: 'https://www.gsaujsummershow2020.com/unit-13/lesego-tsatsimpe'
        },
        {
          name: 'Tiaan Van Niekerk',
          url: 'https://www.gsaujsummershow2020.com/tiaan-van-niekerk'
        },
        {
          name: 'Mbalenhle Vilakazi',
          url: 'https://www.gsaujsummershow2020.com/unit-13/mbalenhle-vilakazi'
        },
        {
          name: 'Phitlhello Sedibe',
          url: 'https://www.gsaujsummershow2020.com/unit-13/phitlhello-sedibe'
        },
        {
          name: 'Kirsten Fouché',
          url: 'https://www.gsaujsummershow2020.com/kirsten-fouche'
        },
        {
          name: 'Cornel	Hugo',
          url: 'https://www.gsaujsummershow2020.com/cornel-hugo'
        },
        {
          name: 'Franklin	Ndhlovu',
          url: 'https://www.gsaujsummershow2020.com/franklin-ndhlovu'
        },
        {
          name: 'Alex Pottie',
          url: 'https://www.gsaujsummershow2020.com/unit-13/alex-pottie'
        },
        {
          name: 'Aaron Servant',
          url: 'https://www.gsaujsummershow2020.com/aaron-servant'
        },
        {
          name: 'Gerald	Titus',
          url: 'https://www.gsaujsummershow2020.com/gerald-titus'
        },
        {
          name: 'Saanye	Zahidi',
          url: 'https://www.gsaujsummershow2020.com/saanye-zahidi'
        }
      ]
    },
    {
      id: 2,
      url: "https://gsa-pointclouds.s3.af-south-1.amazonaws.com/unit-14/index.html",
      name: "Unit 14",
      image:  unit14img,
      students: [
        {
          name: 'Dylan Fernandes',
          url: 'https://www.gsaujsummershow2020.com/dylan-fernades'
        },
        {
          name: 'Neetesh Ramnath',
          url: 'https://www.gsaujsummershow2020.com/unit-14/neetesh-ramnath'
        },
        {
          name: 'Gio Rech',
          url: 'https://www.gsaujsummershow2020.com/unit-14/gio-rech'
        },
        {
          name: 'Sune Shaw',
          url: 'https://www.gsaujsummershow2020.com/unit-14/sune-shaw'
        },
        {
          name: 'Jodie Winterton',
          url: 'https://www.gsaujsummershow2020.com/unit-14/jodie-winterton'
        },
        {
          name: 'Jackson Chanje',
          url: 'https://www.gsaujsummershow2020.com/unit-14/jackson-chanje'
        },
        {
          name: 'Jana Cloete',
          url: 'https://www.gsaujsummershow2020.com/jana-cloete'
        },
        {
          name: 'Azraa Gabru',
          url: 'https://www.gsaujsummershow2020.com/unit-14/azraa-gabru'
        },
        {
          name: 'Sarah Harding',
          url: 'https://www.gsaujsummershow2020.com/sarah-harding'
        },
        {
          name: 'Jaco Maritz',
          url: 'https://www.gsaujsummershow2020.com/unit-14/jaco-maritz'
        }
      ]
    },
    {
      id: 3,
      url: "https://gsa-pointclouds.s3.af-south-1.amazonaws.com/unit-15/index.html",
      name: "Unit 15x",
      image:  unit15img,
      students: [
        {
          name: 'Mohamed Ismail',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/mohamed-ismail'
        },
        {
          name: 'Linda Lesolle',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/linda-lesolle'
        },
        {
          name: 'Tsaukani Masilela',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/tsaukani-masilela'
        },
        {
          name: 'Lutho Matanda',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/lutho-matanda'
        },
        {
          name: 'Tinotenda Ncube',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/tinotenda-ncube'
        },
        {
          name: 'Swelihle Njokwe',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/swelihle-njokwe'
        },
        {
          name: 'Sanelisiwe	Peta',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/sanelisiwe-peta'
        },
        {
          name: 'Ntombizethu Shube',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/ntombizethu-shube'
        },
        {
          name: 'Claudine Williams',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/claudine-williams'
        },
        {
          name: 'Zolani Gomba',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/zolani-armede-gomba'
        },
        {
          name: 'Boniswa Duma',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/boniswa-duma'
        },
        {
          name: 'Lethabo Mathabathe',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/lethabo-mathabathe'
        },
        {
          name: 'Bontle	Moumakoe',
          url: 'https://www.gsaujsummershow2020.com/unit-15x/bontle-moumakoe'
        }
      ]
    },
    {
      id: 5,
      url: "https://gsa-pointclouds.s3.af-south-1.amazonaws.com/unit-17/index.html",
      name: "Unit 17",
      image:  unit17img,
      students: [
        {
          name: 'Nobubele Jele',
          url: 'https://www.gsaujsummershow2020.com/unit-17/nobubele-jele'
        },
        {
          name: 'Dylan Richards',
          url: 'https://www.gsaujsummershow2020.com/unit-17/dylan-richards'
        },
        {
          name: 'Bhongo Mbobo',
          url: 'https://www.gsaujsummershow2020.com/unit-17/bhongo-mbobo'
        },
        {
          name: 'Wade Hassett',
          url: 'https://www.gsaujsummershow2020.com/unit-17/wade-glenn-hassett'
        },
        {
          name: 'Tyron Stephan',
          url: 'https://www.gsaujsummershow2020.com/unit-17/tyron-stephan'
        },
        {
          name: 'Tebogo Kgatla',
          url: 'https://www.gsaujsummershow2020.com/unit-17/tebogo-kgatla'
        },
        {
          name: 'Hanle Mothilal',
          url: 'https://www.gsaujsummershow2020.com/unit-17/hanle-mothilal'
        },
        {
          name: 'Ivan Andonov',
          url: 'https://www.gsaujsummershow2020.com/unit-17/ivan-andonov'
        },
        {
          name: 'Sean Stevenson',
          url: 'https://www.gsaujsummershow2020.com/unit-17/sean-stevenson'
        },
        {
          name: 'Ruan Potgieter',
          url: 'https://www.gsaujsummershow2020.com/unit-17/ruan-potgieter'
        },
        {
          name: 'Ishmael Mashaba',
          url: 'https://www.gsaujsummershow2020.com/unit-17/ishmael-mashaba'
        },
        {
          name: 'Edward Bikitsha',
          url: 'https://www.gsaujsummershow2020.com/unit-17/edward-bikitsha'
        }
      ]
    },
    {
      id: 6,
      url: "https://gsa-pointclouds.s3.af-south-1.amazonaws.com/unit-18/index.html",
      name: "Unit 18",
      image:  unit18img,
      students: [
        {
          name: 'Meghana Patel',
          url: 'https://www.gsaujsummershow2020.com/unit-18/meghana-patel'
        },
        {
          name: 'Gila Abrams',
          url: 'https://www.gsaujsummershow2020.com/unit-18/gila-abrams'
        },
        {
          name: 'Natalie Harper',
          url: 'https://www.gsaujsummershow2020.com/unit-18/natalie-harper'
        },
        {
          name: 'Siwelile Mathenjwa',
          url: 'https://www.gsaujsummershow2020.com/siwelile-mathenjwa'
        },
        {
          name: 'Fathima Bibi Mula',
          url: 'https://www.gsaujsummershow2020.com/fathima-mula'
        },
        {
          name: 'Mpho Luna Molaoa',
          url: 'https://www.gsaujsummershow2020.com/unit-18/mpho-molaoa'
        },
        {
          name: 'Atiyyah Ameen',
          url: 'https://www.gsaujsummershow2020.com/unit-18/atiyyah-ameen'
        },
        {
          name: 'Leo Da Silva Chicwambi',
          url: 'https://www.gsaujsummershow2020.com/unit-18/leo-chicwambi'
        },
        {
          name: 'Jana Crous',
          url: 'https://www.gsaujsummershow2020.com/unit-18/jana-crous'
        },
        {
          name: 'Izak Potgieter',
          url: 'https://www.gsaujsummershow2020.com/izak-potgieter'
        },
        {
          name: 'Kamal Ranchod',
          url: 'https://www.gsaujsummershow2020.com/kamal-ranchod'
        },
        {
          name: 'Thelma Ndebele',
          url: 'https://www.gsaujsummershow2020.com/thelma-ndebele'
        },
        {
          name: 'Jessica Cristovao',
          url: 'https://www.gsaujsummershow2020.com/unit-18/jessica-cristovao'
        },
        {
          name: 'Karabo Moumakwe',
          url: 'https://www.gsaujsummershow2020.com/karabo-moumakwe'
        },
        {
          name: 'Nothando  Lunga',
          url: 'https://www.gsaujsummershow2020.com/nothando-lunga'
        },
        {
          name: 'Gloria Pavita',
          url: 'https://www.gsaujsummershow2020.com/unit-18/gloria-pavita'
        },
        {
          name: 'Zahraa Essa',
          url: 'https://www.gsaujsummershow2020.com/unit-18/zahraa-essa'
        }
      ]
    },
    {
      id: 7,
      url: "https://gsa-pointclouds.s3.af-south-1.amazonaws.com/unit-19/index.html",
      name: "Unit 19",
      image:  unit19img,
      students: [
        {
          name: 'Debra Bhungeni',
          url: 'https://www.gsaujsummershow2020.com/unit-19/debra-bhungeni'
        },
        {
          name: 'Greg Cousins',
          url: 'https://www.gsaujsummershow2020.com/gregory-cousins'
        },
        {
          name: 'Tshwanelo Kubayi',
          url: 'https://www.gsaujsummershow2020.com/unit-19/tshwanelo-kubayi'
        },
        {
          name: 'Katlego Malebye',
          url: 'https://www.gsaujsummershow2020.com/katlego-malebye'
        },
        {
          name: 'Brighton Matambo',
          url: 'https://www.gsaujsummershow2020.com/unit-19/brighton-matambo'
        },
        {
          name: 'Tuki Matibedi',
          url: 'https://www.gsaujsummershow2020.com/unit-19/tuki-mathibedi'
        },
        {
          name: 'Thandeka Mnguni',
          url: 'https://www.gsaujsummershow2020.com/thandeka-mnguni'
        },
        {
          name: 'Miliswa Ndziba',
          url: 'https://www.gsaujsummershow2020.com/unit-19/miliswa-ndziba'
        },
        {
          name: 'Masego Rakumakwe',
          url: 'https://www.gsaujsummershow2020.com/shiloh-rakumakwe'
        },
        {
          name: 'Dimpho Selepe',
          url: 'https://www.gsaujsummershow2020.com/unit-19/dimpho-selepe'
        },
        {
          name: 'Lynette Boshoff',
          url: 'https://www.gsaujsummershow2020.com/unit-19/lynette-boshoff'
        },
        {
          name: 'Byron Corrigan',
          url: 'https://www.gsaujsummershow2020.com/byron-corrigan'
        },
        {
          name: 'Ivan Meyer',
          url: 'https://www.gsaujsummershow2020.com/unit-19/ivan-meyer'
        }
      ]
    }
  ]
}